export default {"src":"/_next/static/media/eye-icon.5e66eab7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};